import manual_billing_line_config from "@/components/ManualBillingLine/config";

export default {
  singleLabel: "Facture manuelle",
  storeNamespace: 'manual_billing',
  authFeature: 'manual-billing',
  listRouteName: "ManualBillingList",
  newRouteName: "ManualBillingNew",
  editRouteName: "ManualBillingEdit",
  detailRouteName: "ManualBillingDetail",
  useNewModal: true,
  modal_size: 'xl',
  useEditModal: true,
  formComponentName: 'ManualBillingForm',
  showExtendedFilters: true,
  csvExportFilenamePrefix: 'factures-manuelles',
  pdf_export_logo: 'axiloc',
  pdf_export_extra_content_before: function (rawValues, values, context) {
    let extra_content = []
    extra_content.push({
      columns: [{
          table: {
            body: [
              [
                ["Logistique Outillage Nantes"]
              ],
              [
                ["17 rue de la Mainguais"]
              ],
              [
                ["44470 Carquefou"]
              ],
              [
                ["Tel : 02 40 13 65 42"]
              ],
              [
                ["Fax : 02 40 13 65 44"]
              ]
            ]
          },
          layout: 'noBorders'
        },
        {
          table: {
            body: [
              ["Titre : ", rawValues.manual_billing_title || '-'],
              ["Date : ", rawValues.billing_date ? context.$moment(rawValues.billing_date).format("DD-MM-YYYY") : '-'],
              ["Agence : ", rawValues.agency && rawValues.agency.internal_number && rawValues.agency.name ? rawValues.agency.internal_number + ' ' + rawValues.agency.name : '-'],
              ["Affaire : ", rawValues.business && rawValues.business.name ? rawValues.business.name : '-'],
              ["Type :", rawValues.bill_type_slug && context.$store.getters['manual_billing/getType'](rawValues.bill_type_slug) ? context.$store.getters['manual_billing/getType'](rawValues.bill_type_slug).text : '-']
            ]
          },
          layout: 'noBorders'
        }
      ]
    })
    return extra_content
  },
  pdf_export_extra_content_after: function (rawValues, values) {
    let extra_content = []
    extra_content.push({
      table: {
        widths: ["*", "*", "*", "*", "*", "*"],
        body: [
          [null, null, null, null, "Total : ", values.bill_total || '-']
        ]
      },
      layout: 'noBorders',
      bold: true,
      fontSize: 12,
    })
    return extra_content
  },
  titleField: 'manual_billing_number',
  sortBy: 'id',
  sortDesc: true,
  fields: [{
      name: 'manual_billing_number',
      label: "Numéro de facture",
      type: 'text',
      inForm: false,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: false,
      inCsvExport: true,
      inPdfExport: false,
    },
    {
      name: 'manual_billing_title',
      label: "Titre",
      type: 'text',
      inForm: true,
      required: true,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: false,
      inCsvExport: true,
      inPdfExport: false,
    },
    {
      name: 'billing_date',
      label: "Date",
      type: 'date',
      inForm: true,
      required: true,
      inList: true,
      sortable: true,
      extendedFilter: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: false,
      formatter: (context, value) => value ? context.$moment(value).format("DD-MM-YYYY") : null,
      disabledDates: (form) => {
        let date;
        if (form.id) {
          date = new Date(form.billing_date);
        } else {
          date = new Date();
          date.setDate(date.getDate() - 1);
        }
        return { to: date };
      }
    },
    {
      name: 'internal_billing',
      label: "Facture interne",
      type: 'select',
      inForm: false,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
      detailLink: 'InternalBillingDetail',
      inCsvExport: true,
      inPdfExport: false,
      formatter: (context, value) => value && value.internal_billing_number ? value.internal_billing_number : null
    },
    {
      // 'autocomplete' : la table des maintenances externes dépasse 100 000 lignes, un
      // <select> en chargeait la totalité. Le composant cherche côté serveur à la frappe.
      name: 'external_maintenance_id',
      label: "Maintenance externe",
      type: 'autocomplete',
      component: 'ExternalMaintenanceAutocomplete',
      placeholder: "Numéro de maintenance…",
      inForm: true,
    },
    {
      name: 'external_maintenance',
      label: "Maintenance externe",
      type: 'select',
      inForm: false,
      inList: false,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: false,
      formatter: (context, value) => value && value.maintenance_number ? value.maintenance_number : null
    },
    {
      // 'autocomplete' : 644 agences à dérouler dans un <select>. Elles tiennent dans le
      // store, la recherche reste donc locale — même composant que le filtre des affaires.
      name: 'agency_id',
      label: "Agence",
      type: 'autocomplete',
      component: 'AgencyAutocomplete',
      placeholder: "Code ou nom d'agence…",
      inForm: true,
    },
    {
      name: 'agency',
      label: "Agence",
      type: 'chosen',
      inList: true,
      sortable: true,
      filterIn: true,
      extendedFilter: true,
      formatter: (context, value) => value && value.internal_number && value.name ? value.internal_number + ' ' + value.name : null,
      inCsvExport: true,
    },
    {
      name: 'agency',
      label: "Agence",
      type: 'select',
      inDetail: true,
      formatter: (context, value) => value && value.internal_number && value.name ? value.internal_number + ' ' + value.name : null
    },
    {
      // 'autocomplete' : la liste est chargée par agence, ce qui fait tout de même 1 500
      // affaires en moyenne et plus de 20 000 pour la plus grosse agence. Elle est filtrée
      // par la vue (statut, imputable), d'où le composant adossé à `business_id_options`.
      // L'invite dépend du formulaire : sans agence, il n'y a rien à proposer.
      name: 'business_id',
      label: "Affaire",
      type: 'autocomplete',
      component: 'OptionsAutocomplete',
      placeholder: (form) => form.agency_id
        ? "Numéro ou nom d'affaire…"
        : "Sélectionnez d'abord une agence",
      inForm: true,
      required: true,
    },
    {
      name: 'business',
      label: "Affaire",
      type: 'select',
      inForm: false,
      required: true,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
      inCsvExport: true,
      formatter: (context, value) => value && value.name ? value.number+' - '+value.name : null
    },
    {
      // 'autocomplete' : la liste des demandeurs dépasse 23 000 comptes (tous ceux qui ne sont
      // pas rattachés à une agence cliente s'y retrouvent, quelle que soit l'agence choisie).
      // Elle est filtrée par la vue, d'où le composant générique adossé à `user_id_options`.
      name: 'user_id',
      label: "Demandeur",
      type: 'autocomplete',
      component: 'OptionsAutocomplete',
      placeholder: "Nom ou prénom du demandeur…",
      inForm: true,
      required: true,
    },
    {
      name: 'user',
      label: "Demandeur",
      type: 'select',
      inForm: false,
      required: true,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
      inCsvExport: true,
      formatter: (context, value) => value && value.firstname && value.lastname ? value.lastname+' '+value.firstname : null
    },
    {
      name: 'bill_type_slug',
      label: "Type",
      type: 'select',
      inForm: true,
      required: true,
      inList: true,
      tabFilter: true,
      inDetail: true,
      inCsvExport: true,
      formatter: (context, value) => value ? context.$store.getters['manual_billing/getType'](value) ? context.$store.getters['manual_billing/getType'](value).text : null : null
    },
    {
      name: 'group_slug',
      label: "Service",
      type: 'select',
      inForm: true,
      required: true,
      inList: true,
      sortable: true,
      extendedFilter: true,
    },
    {
      // Filtre seul (pas de colonne) : factures reprises de MCS (ventes, frais et pertes
      // facturés dans MCS avant la MEP). Alimenté par manual_billing.from_mcs.
      name: 'from_mcs',
      label: "Origine",
      type: 'select',
      inForm: false,
      inList: false,
      inDetail: false,
      inCsvExport: false,
      inPdfExport: false,
      extendedFilter: true,
    },
    {
      name: 'group_slug',
      label: "Service",
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      formatter: (context, value) => value ? context.$store.getters['renting_preparation/getGroup'](value).text : null
    },
    {
      name: 'bill_total',
      label: "Total",
      type: 'number',
      step: 0.01,
      inForm: false,
      inList: true,
      sortable: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      // Format français, aligné sur la facturation automatique : séparateur de milliers
      // et virgule décimale, espace avant le symbole (« 8 835,00 € »).
      formatter: (context, value) => value || value === 0
        ? parseFloat(value).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'
        : null
    },
    {
      name: 'created_at',
      label: "Création",
      type: 'date',
      inForm: false,
      inList: false,
      inDetail: false,
      inPdfExport: false,
      formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
    },
    {
      name: 'updated_at',
      label: "Dernière modification",
      type: 'date',
      inForm: false,
      inList: false,
      inDetail: false,
      inPdfExport: false,
      formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
    },
    {
      name: 'created_at',
      label: "Création",
      type: 'date',
      inCsvExport: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD/MM/YYYY") : null
    },
    {
      name: 'updated_at',
      label: "Dernière modification",
      type: 'date',
      inCsvExport: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD/MM/YYYY") : null
    },
    {
      name: 'manual_billing_lines',
      label: "Lignes de facturation",
      type: 'group_repeater',
      inForm: true,
      required: true,
      // Cinq champs alignés sans étiquette : rien ne disait ce qu'on saisissait, la liste
      // déroulante des pièces moins que tout. Les colonnes sont nommées une fois en tête,
      // et le prix comme la quantité n'occupent plus la largeur d'un commentaire.
      showFieldLabels: true,
      fields: [{
          name: 'spare_part_id',
          label: "Pièce de rechange",
          type: 'select',
          required: false,
        },
        {
          name: 'line_title',
          label: "Titre",
          type: 'text',
          required: true,
        },
        {
          name: 'line_comment',
          label: "Commentaire",
          type: 'text',
          required: true,
        },
        {
          name: 'unit_price',
          label: "Prix unitaire",
          type: 'number',
          step: 0.01,
          required: true,
          width: '130px',
          formatter: (context, value) => value ? parseFloat(value).toFixed(2) + '€' : null
        },
        {
          name: 'quantity',
          label: "Quantité",
          type: 'number',
          required: true,
          width: '100px',
        }
      ]
    },
    {
      name: 'manual_billing_lines',
      label: "Lignes de facturation",
      type: 'list',
      icone: 'euro-sign',
      config: manual_billing_line_config,
      fields: [
        'line_title',
        'line_comment',
        'spare_part',
        'unit_price',
        'quantity',
        'total'
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/ManualBilling/config.js